interface HeaderProps {
  title: string;
}

function Header(props: HeaderProps) {
  const { title } = props;
  return (
    <header
      className="flex justify-center bg-purple-100 text-gray-700 p-3 shadow-sm font-serif"
    >
      <h1 
        className="text-3xl font-bold text-center"
      >
        { title }
      </h1>
    </header>
  );
}

export default Header;